// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"5e594a1c","42":"38e696a2","95":"e2c1725c","498":"7c8ee2c4","528":"21ec643b","561":"14d440ca","643":"c0a9f0f6","718":"c7b4664c","953":"3562622c","997":"e99711aa"}[chunkId] + ".chunk.js";
};